module.exports = __webpack_public_path__ + "img/logo1.a93a159b.png";